import { render, staticRenderFns } from "./add-relevance-relation.vue?vue&type=template&id=510e26fc"
import script from "./add-relevance-relation.vue?vue&type=script&lang=ts"
export * from "./add-relevance-relation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports